<script setup lang="ts">
    import { defineProps, withDefaults, toRefs, ref } from "vue";
    import { flashWarning } from "@/utils";
    import { useStore } from "@/store";
    import KAutocomplete from "@/components/forms/inputs/Autocomplete/KAutocomplete.vue";
    import { convertMaterialData } from "@/tabs/Admin/forms/materialConverter";
    import { Material } from "@/tabs/Admin/forms/materialConverter";

    interface Props {
        name: string;
        label: string;
        value?: unknown;
        urlParams?: { [key: string]: unknown };
    }

    const props = withDefaults(defineProps<Props>(), {
        name: "material",
        label: "Material",
        value: () => null,
        urlParams: () => ({}),
    });

    const store = useStore();
    const { name, label, value, urlParams } = toRefs(props);
    const convertedOptions = ref<any[]>([]);

    const fetchMaterial = async ({ query }: { query?: string } = {}) => {
        try {
            const params: { q?: string } = {};

            if (query) {
                params.q = query;
            }

            const { subsetName } = await store.dispatch("material/fetchMaterial", {
                limit: 40,
                page: 1,
                filterParams: {
                    ...params,
                    ...(urlParams?.value ?? {}),
                },
            });

            const materials = store.getters["material/materialSubset"]({
                subsetName,
                offset: 0,
                limit: 40,
            });

            convertedOptions.value = materials.map((material: Material) => convertMaterialData(material));

            return convertedOptions.value;
        } catch (error) {
            console.error("Kunde inte hämta material:", error);
            flashWarning("Kunde inte hämta material");
            return [];
        }
    };
</script>

<template>
    <KAutocomplete
        v-bind="$attrs"
        :name="name"
        :label="label"
        :options="fetchMaterial"
        :on-search="fetchMaterial"
        :value="value"
    />
</template>

<style scoped lang="scss"></style>
